import { SystemModule } from '@/core/types/SystemModule.ts'
import useHasPermissions from '@/core/hooks/useHasPermissions.ts'

export const useGetAccessibleViewFromModule = () => {
  const { hasPermissions } = useHasPermissions()

  const getFirstAccessibleView = (module: SystemModule) =>
    module.views.find((view) => hasPermissions([view.permission]))

  return {
    getFirstAccessibleView
  }
}
